import bcrypt from 'bcryptjs'

const SALT_ROUNDS = 10

/**
 * Dummy hash for timing-safe login.
 * Used when the user does not exist to avoid timing attacks.
 */
export const DUMMY_HASH = '$2a$10$N9qo8uLOickgx2ZMRZoMyeUv9rT7dRVqTMtKYzOYQVxZi1qU2cFaW'

/**
 * Hashes a password with bcrypt
 */
export function hashPassword(password: string): Promise<string> {
  return bcrypt.hash(password, SALT_ROUNDS)
}

/**
 * Verifies a password against its hash
 */
export function verifyPassword(password: string, hash: string): Promise<boolean> {
  return bcrypt.compare(password, hash)
}
